import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Icon, Monogram, Skeleton, SectionHead, EmptyState } from "../ui";

const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });

export function InsightsList() {
  const { api } = useAuth();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/property-desk/insights").then((r) => setRows(r.data.insights)).catch(() => setRows([])); }, [api]);
  const [lead, ...rest] = rows || [];
  return (
    <div className="pt-28 md:pt-36 max-w-[1400px] mx-auto px-6 md:px-10 pb-20" data-testid="pd-insights-page">
      <SectionHead label="Market Insights" title="Intelligence from the desk." />
      {!rows ? <div className="grid md:grid-cols-3 gap-8">{[0, 1, 2].map((i) => <Skeleton key={i} />)}</div>
        : !rows.length ? <EmptyState text="Our first market intelligence briefings are being prepared. Insight arrives by invitation of the desk." />
        : (
          <>
            <Link to={`/property-desk/insights/${lead.slug}`} className="pd-card grid lg:grid-cols-[1.3fr_1fr] mb-16" data-testid={`pd-insight-lead-${lead.id}`}>
              <div className="pd-img-wrap aspect-[16/10] lg:aspect-auto lg:min-h-[480px]">{lead.cover_url ? <img src={lead.cover_url} alt="" /> : <Monogram />}</div>
              <div className="p-10 md:p-14 flex flex-col justify-center"><div className="pd-label mb-5">{fmt(lead.publish_date)} · {lead.read_minutes} min</div><h2 className="pd-serif text-4xl md:text-5xl leading-tight">{lead.title}</h2>{lead.subtitle && <p className="pd-muted mt-6 text-lg leading-relaxed">{lead.subtitle}</p>}<span className="pd-nav-link mt-10 inline-flex items-center gap-2">Read the briefing <Icon.Arrow size={14} /></span></div>
            </Link>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {rest.map((a) => <Link key={a.id} to={`/property-desk/insights/${a.slug}`} className="pd-card" data-testid={`pd-insight-card-${a.id}`}><div className="pd-img-wrap aspect-[16/10]">{a.cover_url ? <img src={a.cover_url} alt="" /> : <Monogram />}</div><div className="p-7"><div className="pd-label mb-3">{fmt(a.publish_date)}</div><h3 className="pd-serif text-2xl leading-tight">{a.title}</h3></div></Link>)}
            </div>
          </>
        )}
    </div>
  );
}

export function InsightArticle() {
  const { slug } = useParams();
  const { api } = useAuth();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { setD(null); api.get(`/property-desk/insights/${slug}`).then((r) => setD(r.data)).catch(() => setErr("This insight is not available.")); }, [api, slug]);
  if (err) return <div className="pt-40 text-center pd-serif text-3xl">{err}</div>;
  if (!d) return <div className="pt-20"><div className="pd-skeleton h-[60vh]" /></div>;
  const a = d.insight;
  return (
    <article className="pt-20" data-testid="pd-insight-article">
      <div className="pd-img-wrap h-[55vh] md:h-[70vh]">{a.cover_url ? <img src={a.cover_url} alt="" /> : <Monogram />}<div className="absolute inset-0 pd-hero-overlay" /></div>
      <div className="max-w-3xl mx-auto px-6 -mt-32 relative">
        <div className="pd-label mb-5">{fmt(a.publish_date)} · {a.author} · {a.read_minutes} min read</div>
        <h1 className="pd-serif text-5xl md:text-6xl leading-[1.05] tracking-wide">{a.title}</h1>
        {a.subtitle && <p className="pd-serif italic text-2xl pd-muted mt-6 leading-relaxed">{a.subtitle}</p>}
        <div className="pd-prose mt-14 text-lg leading-[1.95] text-[#D9D9D0]">{a.body.split(/\n{2,}/).map((p, i) => <p key={i}>{p}</p>)}</div>
        {a.tags?.length > 0 && <div className="flex flex-wrap gap-2 mt-12">{a.tags.map((t) => <span key={t} className="pd-tag">{t}</span>)}</div>}
      </div>
      {d.more?.length > 0 && <div className="max-w-[1400px] mx-auto px-6 md:px-10 pd-section"><SectionHead label="Continue reading" /><div className="grid md:grid-cols-3 gap-8">{d.more.map((m) => <Link key={m.id} to={`/property-desk/insights/${m.slug}`} className="pd-card"><div className="pd-img-wrap aspect-[16/10]">{m.cover_url ? <img src={m.cover_url} alt="" /> : <Monogram />}</div><div className="p-7"><h3 className="pd-serif text-2xl">{m.title}</h3></div></Link>)}</div></div>}
    </article>
  );
}
